export default __webpack_public_path__ + "static/media/logo.52b197d8.svg";